/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output } from '@angular/core';

/**
 * Service imports.
 */
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';

/**
 * Basic info card contains the banner, title, paragraph.
 */
@Component({
  selector: 'app-basic-info-card',
  templateUrl: './basic-info-card.component.html',
  styleUrls: ['./basic-info-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasicInfoCardComponent {

  /**
   * Set the Banner src.
   * Set the heading.
   * Set the paragraph.
   * Set the character limit for para.
   * Set the sponsor logo.
   * Set the sponsor name
   * Attempted date.
   * Show the down arrow.
   * Show/Hide the description.
   */
  @Input() banner: string;
  @Input() heading: string;
  @Input() paragraph: string;
  @Input() charLimit: number;
  @Input() sponsorLogo: number;
  @Input() sponsorName: string;
  @Input() attemptedDate: number;
  @Input() showDownArrow: boolean;
  @Input() showDescription = true;
  @Output() sponsorClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isImageBanner: boolean; 
  @Input() isNavenabled: boolean;

  /**
   * Only Multi lang service is allowed.
   */
  constructor(public mls: NewLanguageService) { }
  
  /**
   * Emit sponsor click event
   */
  private emitSponsorClick(): void {
    this.sponsorClick.emit(true);
  }
}
